import { useDebouncedCallback as useDebounce } from 'use-debounce';

const useDebouncedCallback = (
  callback: (e: any) => Promise<void>,
  wait = 400,
) => {
  return useDebounce(callback, wait);
};

export default useDebouncedCallback;
